import React from 'react'
import styles from './RemoveLinkedItemsContent.module.scss'
import CustomModalFooter from './CustomModalFooter'
import { ReactComponent as WarningIcon } from '../../../assets/icons/warning.svg'
import { COLORS } from '../../../constants/colors'

const WarningModalContent = ({ confirmAction, closeModal, title, description }) => {
  const footerConfig = [
    { id: 1, title: 'Cancel', secondary: true, onClick: closeModal, type: 'button' },
    { id: 2, title: 'Delete', onClick: confirmAction, type: 'button', backgroundColor: COLORS.red },
  ]

  return (
    <div className={styles.container}>
      <WarningIcon width={48} height={48} />
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.descriptionContainer}>
        {description &&
          description.map((paragraph, index) => {
            return (
              <p className={styles.description} key={index}>
                {paragraph}
              </p>
            )
          })}
      </div>
      <CustomModalFooter config={footerConfig} />
    </div>
  )
}

export default WarningModalContent
